"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TooltipStyles = void 0;
var core_1 = require("@material-ui/core");
var commons_1 = require("../../../style/commons");
exports.TooltipStyles = (0, core_1.makeStyles)(function () { return ({
    tooltip: {
        color: commons_1.white,
        zIndex: 10000000,
        borderRadius: '4px',
        backgroundColor: commons_1.darkSecondary,
        margin: '0',
        width: 'auto',
        minWidth: '44px',
        maxWidth: '205px',
        height: '100%',
        fontFamily: 'Roboto',
        fontSize: '12px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '16px',
        letterSpacing: 'normal',
        textAlign: 'center',
        padding: '4px 8px',
    },
    tooltipPlacementLeft: {
        marginRight: '2px',
    },
    tooltipPlacementRight: {
        marginLeft: '2px',
    },
}); });
